import styled from 'styled-components'

import analytics, { AnalyticsEvent, AnalyticsEventTrigger } from '../../util/analytics'
import { Image } from '../../components/Image'

const Thumbnail = styled(Image)`
  width: 130px;
  height: 80px;
  margin: 10px 0;
`

const DetailPanel = styled(Image)`
  height: 300px;
`

export function RenderImage({ observation, onViewImage }) {
  const images = observation?.assetImageUrls || observation?.imageNames || []
  const previewUrl = observation?.assetPreviewUrl || observation?.imagePath
  const imagePaths = observation?.assetImagePaths || observation?.imagePaths

  let filePath = observation?.tags?.includes('v2') ? imagePaths?.[0] : `${imagePaths?.[0]}_t`
  if (observation?.imagePaths) {
    filePath = observation?.imagePaths[0]
  }

  const ImageComponent = observation?.imagePaths ? DetailPanel : Thumbnail

  return (
    <ImageComponent
      path={previewUrl || undefined}
      fileName={images[0]}
      filePath={filePath}
      description="observation preview"
      onClick={(e) => {
        e.stopPropagation()
        analytics.track(AnalyticsEvent.ReportsRowPicture, AnalyticsEventTrigger.click)

        onViewImage?.({
          images,
          path: previewUrl,
          imagePaths,
          observationId: observation.id,
          timezone: observation.timezone,
        })
      }}
    />
  )
}
